var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "menu-popup-host",
      class: { "menu-popup-host--fixed": _vm.fixed },
    },
    [
      _c(
        "Popup",
        _vm._b(
          {
            ref: "menuPopup",
            attrs: {
              active: _vm.isPopupOpen,
              animation: "fade",
              transparentBg: false,
              fullsize: false,
              align: _vm.isDropdown ? "left" : "right",
              valign: "bottom",
              hasBg: _vm.isMobile,
              borderRadiusBySide: _vm.borderRadiusBySide,
              showHeader: "",
              headerVariant:
                _vm.isMobile && _vm.showMenuTabBar ? "tabs" : "default",
            },
            on: { close: _vm.toggleClose },
            scopedSlots: _vm._u([
              {
                key: "modalHeader",
                fn: function () {
                  return [
                    _vm.isMobile && _vm.showMenuTabBar
                      ? [
                          _c("MenuTabBar", {
                            attrs: {
                              "active-page": _vm.activePopupPage,
                              "schedule-count": _vm.menuScheduleCount,
                            },
                            on: { select: _vm.onMenuTabSelect },
                          }),
                          _vm.activePopupPage === _vm.PopupPage.betDetail
                            ? _c(
                                "div",
                                { staticClass: "bet-detail-subheader" },
                                [
                                  _c(
                                    "Nav",
                                    {
                                      attrs: {
                                        imageURL: _vm.activePopupPage,
                                        toURL: _vm.toURL,
                                        popupLevel: _vm.popupLevel(
                                          _vm.activePopupPage
                                        ),
                                      },
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(_vm.$t(_vm.activePopupPage)) +
                                          " "
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                        ]
                      : _c(
                          "div",
                          { staticClass: "modal-header-wrapper" },
                          [
                            _c(
                              "Nav",
                              {
                                attrs: {
                                  imageURL: _vm.activePopupPage,
                                  toURL: _vm.toURL,
                                  popupLevel: _vm.popupLevel(
                                    _vm.activePopupPage
                                  ),
                                },
                              },
                              [
                                !_vm.isMobile &&
                                _vm.withCommission &&
                                [
                                  _vm.PopupPage.history,
                                  _vm.PopupPage.statement,
                                ].includes(_vm.activePopupPage)
                                  ? [
                                      _c("ToggleBtn", {
                                        attrs: {
                                          leftTxt: _vm.$t("History"),
                                          rightTxt: _vm.$t("Statement"),
                                          value:
                                            _vm.activePopupPage ===
                                            _vm.PopupPage.statement,
                                        },
                                        on: { toggle: _vm.toggleReport },
                                      }),
                                    ]
                                  : !_vm.isMobile &&
                                    [
                                      _vm.PopupPage.help,
                                      _vm.PopupPage.jackpotHelp,
                                    ].includes(_vm.activePopupPage) &&
                                    _vm.config.enableJackpot
                                  ? [
                                      _c("ToggleBtn", {
                                        attrs: {
                                          leftTxt: _vm.$t("General"),
                                          rightTxt: _vm.$t("Jackpot"),
                                          value:
                                            _vm.activePopupPage ===
                                            _vm.PopupPage.jackpotHelp,
                                        },
                                        on: { toggle: _vm.toggleHelp },
                                      }),
                                    ]
                                  : [
                                      _vm._v(
                                        " " +
                                          _vm._s(_vm.$t(_vm.activePopupPage)) +
                                          " "
                                      ),
                                    ],
                              ],
                              2
                            ),
                            !_vm.isMobile
                              ? _c(
                                  "div",
                                  {
                                    staticClass: "close-btn",
                                    on: { click: _vm.toggleClose },
                                  },
                                  [
                                    _c("img", {
                                      attrs: {
                                        src: require("@/assets/images/close.webp"),
                                      },
                                    }),
                                  ]
                                )
                              : _vm._e(),
                          ],
                          1
                        ),
                  ]
                },
                proxy: true,
              },
            ]),
          },
          "Popup",
          {
            modalContainerStyles: _vm.menuContainerStyle,
          },
          false
        ),
        [
          _c(
            "div",
            { staticClass: "menu-popup-shell" },
            [
              _c(
                "div",
                { staticClass: "menu-popup-body" },
                [
                  !_vm.isMobile && _vm.activePopupPage === _vm.PopupPage.main
                    ? _c("MenuMain")
                    : _vm._e(),
                  _vm.activePopupPage === _vm.PopupPage.history
                    ? _c("BetHistory")
                    : _vm._e(),
                  _vm.activePopupPage === _vm.PopupPage.statement
                    ? _c("Statement")
                    : _vm._e(),
                  _vm.activePopupPage === _vm.PopupPage.betDetail
                    ? _c("BetHistoryDetail")
                    : _vm._e(),
                  _vm.activePopupPage === _vm.PopupPage.notification
                    ? _c("NotificationPopup")
                    : _vm._e(),
                  _vm.activePopupPage === _vm.PopupPage.schedule
                    ? _c("SchedulePopup")
                    : _vm._e(),
                  _vm.activePopupPage === _vm.PopupPage.scheduleDetail
                    ? _c("ScheduleDetailPopup")
                    : _vm._e(),
                  _vm.activePopupPage === _vm.PopupPage.help
                    ? _c("HelpContent", { attrs: { isHelpGuide: true } })
                    : _vm._e(),
                  _vm.activePopupPage === _vm.PopupPage.jackpotHelp
                    ? _c("HelpContent", {
                        attrs: {
                          helpSource: _vm.luckyDrawInstantPrizeHelpGuide,
                        },
                      })
                    : _vm._e(),
                  _vm.activePopupPage === _vm.PopupPage.tnc
                    ? _c("TNC")
                    : _vm._e(),
                  _vm.activePopupPage === _vm.PopupPage.jackpotPhysicalHelp
                    ? _c("JackpotPhysicalPopup")
                    : _vm._e(),
                ],
                1
              ),
              _vm.isMobile
                ? _c("MenuFooter", { on: { close: _vm.toggleClose } })
                : _vm._e(),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }